const showDivLink = document.getElementById('showNewsletter');
const legacyNewsletter = document.getElementById('newsletter');

if (showDivLink && legacyNewsletter) {
  showDivLink.addEventListener('click', function (event) {
    event.preventDefault();
    legacyNewsletter.style.display = 'block';
  });

  document.addEventListener('click', function (event) {
    if (!legacyNewsletter.contains(event.target) && event.target !== showDivLink) {
      legacyNewsletter.style.display = 'none';
    }
  });
}

/**
 * Dialog API (cdn.dialogapi.no): `show_handler` adds `.mnm-handle` and opens on click.
 * Other appearances (e.g. spent_time) have no handle — mimic internal `h()` by showing
 * the form + overlay (see widget.v4: form/overlay use display:none until opened).
 */
function openDialogNewsletter() {
  const handle = document.querySelector('.mnm-handle');
  if (handle) {
    handle.click();
    return true;
  }

  const form = document.querySelector('form.mnm-form');
  const overlay = document.querySelector('.mnm-overlay');

  if (form) {
    form.style.display = 'block';
    if (overlay) {
      overlay.style.display = 'block';
    }
    const focusTarget =
      form.querySelector(
        'input:not([type="hidden"]), button, select, textarea, [href]',
      ) || form;
    if (typeof focusTarget.focus === 'function') {
      focusTarget.focus({ preventScroll: true });
    }
    return true;
  }

  return false;
}

function scheduleOpenDialogNewsletter() {
  if (openDialogNewsletter()) return;
  let attempts = 0;
  const maxAttempts = 100;
  const id = window.setInterval(() => {
    attempts += 1;
    if (openDialogNewsletter() || attempts >= maxAttempts) {
      window.clearInterval(id);
    }
  }, 100);
}

document.body.addEventListener('click', (event) => {
  const trigger = event.target.closest('.newsletter-trigger');
  if (!trigger) return;
  event.preventDefault();
  scheduleOpenDialogNewsletter();
});
